import { Container, Stack } from '@mantine/core';
import PageTitle from 'components/PageTitle';
import PAGES from 'constant/pages';
import { useAppName } from 'contexts/AppProvider';
import TableSchoolManagement from 'modules/pages/dacum/schoolManagement/TableSchoolManagement';
import React from 'react';

const SchoolManagementPage = () => {
  const { appName } = useAppName();
  return (
    <Container fluid>
      <Stack>
        <PageTitle
          title={PAGES[appName]?.schoolManagement?.title || ''}
          description={PAGES[appName]?.schoolManagement?.description || ''}
        />
        <TableSchoolManagement />
      </Stack>
    </Container>
  );
};

export default SchoolManagementPage;
